<template>
  <div id="index">
    <div class="scroll-big">
      <div class="head p-r">
        <div class="date">
          <div>{{dateYear}}</div>
          <div>{{dateWeek}} {{dateDay}}</div>
        </div>
        <div class="title">{{orgName}}智慧社会工作云监测系统</div>
        <img src="../assets/image/head-right.png" />
      </div>
      <!--    上面的第一部分 -->
      <div class="top dis-flex  flex-x-between">
        <div class="public-welfare">
          <div class="speed-of-progress-box  dis-flex ">
            <vue-seamless-scroll class=" warp" :class-option="classOption" :data="welfareConfig.data">
              <div class="progress-item" style="width: 5.18rem;" v-for="(item, index) in welfareConfig.data" :key="index">
                <div class="name">{{item[0]}}</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- 项目数据、金额 -->
        <div class=" trustee-box">
          <div class="w-90 dis-flex flex-x-between">
            <div class="data-item">
              <div class="data-title">项目总金额</div>
              <div class="data-unit">(万元)</div>
              <div class="data-num">{{totalys}}</div>
              <!-- <dv-digital-flop class="data-num" :config="config1"  /> -->
            </div>
            <div class="data-item">
              <div class="data-title">项目总数</div>
              <div class="data-unit">(个)</div>
              <div class="data-num">{{totalnum}}</div>
            </div>
            <div class="data-item">
              <div class="data-title">机构总数</div>
              <div class="data-unit">(家)</div>
              <div class="data-num">{{totalorgnum}}</div>
            </div>
          </div>
          <!--  -->
          <div class="trustee dis-flex flex-y-center">
            <el-carousel class="w-100" height="1.5rem" direction="vertical" :autoplay="false" :interval="4000"
              indicator-position="none">
              <el-carousel-item v-for="(item,index) in workerList" :key="index">
                <div class="dis-flex flex-x-between">
                  <div class="trustee-info f-column-c f-x-c ">
                    <div class="trustee-info-title">托管机构</div>
                    <div class="trustee-info-mechanism">
                      <a class="trustee-info-mechanism" :href="getHref2(item.organ_id)" target="_blank">
                      {{item.mechanism}}
                      </a>
                    </div>
                  </div>
                  <div class="social-worker">
                    <div class="social-worker-list">
                      <div class="dis-flex flex-y-center">
                        <div class="worker-list-item p-r m-r-10" v-for="(items,indexs) in item.worker" :key="indexs">
                          <a class="worker-list-item p-r m-r-10" style="display: block;" :href="getHref(items.id)" target="_blank">
                          <img class="worker-icon" v-if="item.danghui" src="../assets/image/danghui.png" />
                          <img class="worker-imgworker-img" :src="items.image" />
                          <div class="worker-name">{{items.name}} </div>
                          <div class="grade">{{items.grade}}</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- -->
        <div class="dynamic">
          <div class="speed-of-progress-box  dis-flex ">
            <vue-seamless-scroll class=" warp" :class-option="classOption" :data="dynamicConfig.data">
              <div class="progress-item" style="width: 5.18rem;" v-for="(item, index) in dynamicConfig.data" :key="index">
                <div class="name">{{item[0]}}</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
      <!-- 中间部分 -->
      <div class="center dis-flex flex-x-between">
        <div class="problem">
          <div class="speed-of-progress-box  dis-flex ">
            <vue-seamless-scroll class=" warp" :class-option="classOption" :data="needs.need2">
              <div class="progress-item" v-for="(item, index) in needs.need2" :key="index">
                <div class="name">{{ item.name }}</div>
                <div class="dis-flex flex-x-between w-100 flex-y-center">
                  <div class="speed">项目进度</div>
                  <div class="progress">
                    <Progress class="progress-bar  active w-30" :percent=Number(item.total_num) :hide-info="true"
                      stroke-color="#e50012" />
                  </div>
                  <div class="funds-red">{{item.total_raio}}</div>
                </div>
                <div class="dis-flex flex-x-between flex-y-center">
                  <div class="speed">经费使用</div>
                  <div class="progress">
                    <Progress class="progress-bar  active w-30" :percent=Number(item.moneynum) :hide-info="true"
                      stroke-color="#e50012" />
                  </div>
                  <div class="funds-red">{{item.moneyraio}}</div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>

        <div class="purchaser">
          <div class="speed-of-progress-box  dis-flex ">
            <vue-seamless-scroll class=" warp" :class-option="classOption" :data="purchaserConfig.data">
              <div class="progress-item" style="width: 6.8rem;" v-for="(item, index) in purchaserConfig.data" :key="index">
                <div class="name">{{ item[1] }}--{{item[0]}}</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- 比例图 -->
        <div class="echart" id="echart-dom">

        </div>
      </div>
      <div class="bottom">
        <div class="bigScreen-city-bg05">
          <el-carousel class="w-100 swiper-h" direction="vertical" :autoplay="true" :interval="4000"
            indicator-position="none">
            <el-carousel-item v-for="(item,index) in needs.need1" :key="index">
              <div class="progress-item bottom-progress" v-for="(v,index) in item" :key="index">
                <div class="name">{{ v.name }}</div>
                <div class="dis-flex m-b-5 flex-x-between w-100 flex-y-center">
                  <div class="speed">项目进度</div>
                  <div class="progress">
                    <Progress class="progress-bar  active" :percent=Number(v.total_num) :hide-info="true"
                      stroke-color="#009fe8" />
                  </div>
                  <div class="funds">{{v.total_raio}}</div>
                </div>
                <div class="dis-flex flex-x-between flex-y-center">
                  <div class="speed">经费使用</div>
                  <div class="progress">
                    <Progress class="progress-bar  active" :percent=Number(v.moneynum) :hide-info="true"
                      stroke-color="#5dc1cf" />
                  </div>
                  <div class="funds">{{v.moneyraio}}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import * as echarts from 'echarts';
  import {
    formatTime
  } from '../utils/index.js';
  export default {
    name: "index",
    data() {
      return {
        classOption: {
          step: 0.36
        },
        workerList: [{
          mechanism: "哈哈哈机构1",
          worker: [{
            name: "社工",
            image: "../assets/image/userimg.jpg",
            danghui: true,
            grade: "社工等级"
          }]
        }, ],
        listData: [{
          'title': '无缝滚动第一行无缝滚动第一行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第二行无缝滚动第二行',
          'date': '2017-12-16'
        }],
        detail: {
          price: 1457812,
          count: 711545,
          mechanism: 4578454,
          people: 44855
        },
        welfareConfig: {
          data: [
            ["XXXXXXXXXXXXX项目1"],
          ],
          align: ['center'],
          rowNum: 6,
          oddRowBGC: 'rgba(9, 37, 50,0)',
          evenRowBGC: 'rgba(10, 32, 50, 0)'
        },
        dynamicConfig: {
          data: [
            ["2021年06月03日", "动态"],
          ],

          align: ['center'],
          rowNum: 6,
          oddRowBGC: 'rgba(9, 37, 50,0)',
          evenRowBGC: 'rgba(10, 32, 50, 0)'
        },
        purchaserConfig: {
          data: [
            ["XXXXX局购买", "XXXXXXXXXXXXXX项目"],
          ],

          align: ['center'],
          rowNum: 6,
          oddRowBGC: 'rgba(9, 37, 50,0)',
          evenRowBGC: 'rgba(10, 32, 50, 0)'
        },
        configArr: [{
            number: 1457812,
          },

        ],
        config1: {
          number: [10, 100],

          animationFrame: 300000,
          content: '{nt}个{nt}元'
        },
        dateYear: "",
        dateDay: "",
        dateWeek: "",
        timing: null,
        weekday: [
          '星期天',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六',
        ],
        totalys: 0,
        totalnum: 0,
        totalorgnum: 0,
        gyneeds: [],
        jz: [],
        snews: [],
        needs: [],
        needdata: {},
        orgName: '',
        myChartdata: [{
            value: 735,
            name: '红丝带项目'
          },
          {
            value: 580,
            name: '橙丝带项目'
          },
          {
            value: 484,
            name: '黄丝带项目'
          },
          {
            value: 300,
            name: '绿丝带项目'
          },
          {
            value: 300,
            name: '蓝丝带项目'
          },
          {
            value: 300,
            name: '紫丝带项目'
          },
          {
            value: 1048,
            name: '金丝带项目'
          },
        ],
      }
    },
    created() {
      this.config1
      this.require(); //获取数据
      this.setTimingFn()

    },
    mounted() {
      // if (this.timer) {
      //   clearInterval(this.timer);
      // } else {
      //   this.timer = setInterval(() => {
      //     this.require(); // methods中请求数据的方法
      //   }, 30000);
      // }
      this.echart()
    },
    destroyed: function() {
      this.timing = null
    },
    methods: {
      setTimingFn() {
        this.timing = setInterval(() => {
          this.dateYear = formatTime(new Date(), 'yyyy年MM月dd日');
          this.dateDay = formatTime(new Date(), 'HH: mm');
          this.dateWeek = this.weekday[new Date().getDay()];
          this.$forceUpdate()
        }, 1000);
      },
      getHref:function(val){
        return "https://www.hainingyunjiance.com/index/socialworker/details.html?id="+val
      },
      getHref2:function(val){
        return "https://www.hainingyunjiance.com/index/organizationstyle/details.html?id="+val
      },
      echart() {
        var chartDom = document.getElementById('echart-dom');
        var myChart = echarts.init(chartDom);
        var myChartdata = this.myChartdata
        console.log(myChartdata)
        var option;

        option = {
          tooltip: {
            trigger: 'item'
          },

          series: [{
            type: 'pie',
            radius: '80%',
            color: [
              "#e50012",
              "#ef8200",
              "#fbfe00",
              "#009844",
              "#008bd5",
              "#796bae",
              "#d9b766"
            ],
            data: myChartdata,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',

              }
            }
          }]
        };

        myChart.setOption(option);

      },
      //首页统计接口联调
      require() {
        var that = this;
        var jzid = this.$route.query.id;
        this.axios.get('api/bigdata/jzdata', {
          'id': jzid
        }).then((res) => {
          if (res.data.code == 1) {
            that.loading = false;
            var needdata = res.data.data;
            that.needdata = res.data.data;
            that.totalys = needdata.totalys;
            that.totalnum = needdata.totalnum;
            that.totalorgnum = needdata.totalorgnum;
            that.welfareConfig.data = needdata.gyneeds;
            that.orgName = needdata.org_name;
            that.dynamicConfig.data = needdata.snews;
            var welfareConfig = {}
            welfareConfig.data = needdata.gyneeds
            welfareConfig.align = ["center"]
            welfareConfig.rowNum = 6
            welfareConfig.oddRowBGC = "rgba(9, 37, 50,0)"
            welfareConfig.evenRowBGC = "rgba(10, 32, 50, 0)"
            that.needs = needdata.needs;
            that.welfareConfig = welfareConfig
            var dynamicConfig = {}
            dynamicConfig.align = ["center"]
            dynamicConfig.rowNum = 6
            dynamicConfig.oddRowBGC = "rgba(9, 37, 50,0)"
            dynamicConfig.evenRowBGC = "rgba(10, 32, 50, 0)"
            dynamicConfig.data = needdata.snews;
            that.dynamicConfig = dynamicConfig
            purchaserConfig
            var purchaserConfig = {}
            purchaserConfig.align = ["center"]
            purchaserConfig.rowNum = 6
            purchaserConfig.oddRowBGC = "rgba(9, 37, 50,0)"
            purchaserConfig.evenRowBGC = "rgba(10, 32, 50, 0)"
            purchaserConfig.data = needdata.needs.need3;
            that.purchaserConfig = purchaserConfig
            var workerList = []
            workerList[0] = needdata.swsinfo
            that.workerList = workerList
            var myChartdata = []
            myChartdata = needdata.myChartdata
            console.log(myChartdata)
            that.myChartdata = myChartdata
            that.echart()
            that.$forceUpdate();
            console.log(this.housedata);
          } else {
            this.$Message.error("暂无数据");
          }
        })
      }

    },
    destroyed() {
      clearTimeout(this.timer)
    },
    components: {

    },

  }
</script>

<!--自己写的样式 避免组件样式全局污染-->
<style scoped>
  @import "../assets/css/index.css";
</style>
<!--需要更改的组件库内样式-->
<style lang="css">
  .dv-scroll-board .rows .ceil {
    padding: 0;
    font-size: 0.2rem;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

  }

  .bottom .el-carousel__item {
    height: 2.15rem;
  }

  .dv-scroll-board .rows {
    width: 100% !important;
    ;
  }

  .dv-scroll-board .rows .row-item {
    width: 100% !important;
    ;
    height: 0.3rem !important;
    line-height: 0.3rem !important;
  }

  .dv-scroll-board .rows {
    height: 1.8rem !important;
  }


  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  /*
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  } */
  .echart {
    width: 5.18rem;
    height: 2.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue